module.exports = __webpack_public_path__ + "assets/img/effective1.4b7a113d.png";